import m from "../../es2015/lang/id_ID";
window.am4lang_id_ID = m;


//////////////////
// WEBPACK FOOTER
// ./lang/id_ID.js
// module id = null
// module chunks = 